import {Matcher} from '@/lib/axiosAddTransforms'
import {dateResponse, restDateResponse} from '@/transformers/utils'

const matchers: Matcher[] = [
  {
    test: /^\/certificates\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/accredited-certificates/`
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return data
        }
        data.results = data.results.map((result) => certificateResponse(result))
        return data
      },
    },
  },
  {
    test: /^\/certificates\/\$bizId\/?$/,
    method: 'delete',
    transform: {
      request: (payload) => {
        const {bizId, id} = payload.data
        payload.url = `/bizs/${bizId}/accredited-certificates/${id}`
        return payload
      },
    },
  },
  {
    test: /^\/certificates\/code\/\$id\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/accredited-certificates/request-code`
        delete payload.data.bizId
        return payload
      },
      response: (data) => {
        if(!data || !data.authCode) {
          return data
        }
        return {
          code: data.authCode,
        }
      },
    },
  },
]

export const certificateResponse = (data) => {
  const {id, orgNm, certNm, endDate, isAvailable} = data
  return {
    id: String(id),
    agency: orgNm,
    certNumber: certNm,
    endDate: dateResponse(endDate),
    restExpiryDate: restDateResponse(dateResponse(endDate)),
    status: isAvailable ? 'success' : 'expired',
  }
}

export default matchers
